import { getDateFormatZulu } from "@/helpers/formatDate";

export class DataFormatter {
  parseUrlParams(query) {
    const [basePath, year, electionType, electionCategory, resultPath] = query;
    
    const params = {
      basePath,
      year,
      electionType,
      electionCategory,
      resultPath,
      electionInstance: electionType === 'balotaje' ? 'balotaje' : 'general',
      typeElection: electionCategory,
    };

    const match = resultPath.match(/([A-Z]{2}-[A-Z]\d{3})\.html/);
    if (match) {
      params.codeComplet = match[1];
      const codeMatch = params.codeComplet.match(/^([A-Z]+-[A-Z]+)(\d+)$/);
      if (codeMatch) {
        params.codeLetter = codeMatch[1];
        params.codeNumber = codeMatch[2];
      } else {
        params.codeLetter = params.codeComplet;
        params.codeNumber = "";
      }
    }

    params.baseUrl = this.generateBaseUrl(params);
    params.endpoint = this.generateEndpoint(params);
    params.urlIframe = this.generateIframe(params);

    return params;
  }

  generateIframe(params){
    const codeLetter = params?.codeLetter;
    const codeNumber = params?.codeNumber;
    const baseIframeUrl = `https://ecp.clarin.com/2023/${params.electionInstance}/index.html#/map`;
    const mapType = "president";
    const locationPath = codeLetter && codeNumber ? `${codeLetter}/${codeLetter}${codeNumber}` : `${codeLetter}/_`;
    return `${baseIframeUrl}/${mapType}/${locationPath}`;
  }

  generateBaseUrl(params) {
    const { year, electionType, typeElection } = params;
    
    const urlMap = {
      'presidente': `/elecciones/${year}/${electionType}/presidente/resultados-`,
      'legislativas': `/elecciones/${year}/generales/legislativas/resultados-ciudad-autonoma-bsas-`,
      'diputados': `/elecciones/${year}/generales/diputados/resultados-`,
      'senadores': `/elecciones/${year}/generales/senadores/resultados-`,
      'default': `/elecciones/${year}/generales/gobernador/resultados-`
    };

    return urlMap[typeElection] || urlMap.default;
  }

  generateEndpoint(params) {
    const dateNow = new Date();
    const timestamp = `${dateNow.getHours()}${dateNow.getMinutes()}`;
    
    const endpointMap = {
      'presidente': `president.json?rv=${timestamp}`,
      'legislativas': `delegatesprov.json?rv=${timestamp}`,
      'diputados': `delegates.json?rv=${timestamp}`,
      'senadores': `senators.json?rv=${timestamp}`,
      'default': `governors.json?rv=${timestamp}`
    };

    return endpointMap[params.typeElection] || endpointMap.default;
  }
}

// Funciones utilitarias exportadas individualmente
export const roundToTwoDecimals = (value) => {
  return parseFloat(value).toFixed(2);
};

export const formatWithCommas = (value) => {
  return value ? value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") : value;
};

export const convertirFecha = (timestamp) => {
  const fecha = new Date(timestamp);
  const year = fecha.getUTCFullYear();
  const month = String(fecha.getUTCMonth() + 1).padStart(2, '0');
  const day = String(fecha.getUTCDate()).padStart(2, '0');
  const hours = String(fecha.getUTCHours()).padStart(2, '0');
  const minutes = String(fecha.getUTCMinutes()).padStart(2, '0');
  const seconds = String(fecha.getUTCSeconds()).padStart(2, '0');

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.000Z`;
};

export const imagePost = {
  "AR-CL1": {
      "code": "AR",
      "url": "/2025/05/05/D7Vf55uaO_1256x620__1.jpg"
      // "url": "/2025/05/13/09bQTM_ku_1256x620__1.jpg"
  },
  "AR-CL2": {
      "code": "AR",
      "url": "/2025/05/05/guB28QpyC_1256x620__1.jpg"
      // "url": "/2025/05/13/pdKKl25Aq_1256x620__1.jpg"
  },
  "AR": {
      "code": "AR",
      "url": "/2023/10/06/OHw4KnSeM_1256x620__1.jpg"
  },
  "AR-B": {
      "code": "AR-B",
      "url": "/2023/10/06/LkE-QQhUR_1256x620__1.jpg"
  },
  "AR-C": {
      "code": "AR-C",
      "url": "/2023/10/06/uE6Heryiz_1256x620__1.jpg"
  },
  "AR-K": {
      "code": "AR-K",
      "url": "/2023/10/06/FG9DR2O-s_1256x620__1.jpg"
  },
  "AR-H": {
      "code": "AR-H",
      "url": "/2023/10/06/T8KyPlGOA_1256x620__1.jpg"
  },
  "AR-U": {
      "code": "AR-U",
      "url": "/2023/10/06/j5jeTOqJY_1256x620__1.jpg"
  },
  "AR-X": {
      "code": "AR-X",
      "url": "/2023/10/06/u2CRYvfEg_1256x620__1.jpg"
  },
  "AR-W": {
      "code": "AR-W",
      "url": "/2023/10/06/cZBFEaYWB_1256x620__1.jpg"
  },
  "AR-E": {
      "code": "AR-E",
      "url": "/2023/10/06/ECse7u6Y1_1256x620__1.jpg"
  },
  "AR-P": {
      "code": "AR-P",
      "url": "/2023/10/06/7P1R3By2n_1256x620__1.jpg"
  },
  "AR-Y": {
      "code": "AR-Y",
      "url": "/2023/10/06/o3_5-gWnE_1256x620__1.jpg"
  },
  "AR-L": {
      "code": "AR-L",
      "url": "/2023/10/06/Z_gcz_1Zj_1256x620__1.jpg"
  },
  "AR-F": {
      "code": "AR-F",
      "url": "/2023/10/06/hF5vQAcj1_1256x620__1.jpg"
  },
  "AR-M": {
      "code": "AR-M",
      "url": "/2023/10/06/g1XTmZou4_1256x620__1.jpg"
  },
  "AR-N": {
      "code": "AR-N",
      "url": "/2023/10/06/YUWEO6PW6_1256x620__1.jpg"
  },
  "AR-Q": {
      "code": "AR-Q",
      "url": "/2023/10/06/f86TViSS4_1256x620__1.jpg"
  },
  "AR-R": {
      "code": "AR-R",
      "url": "/2023/10/06/n8Nh-Iy-o_1256x620__1.jpg"
  },
  "AR-A": {
      "code": "AR-A",
      "url": "/2023/10/06/HYCafS1mE_1256x620__1.jpg"
  },
  "AR-J": {
      "code": "AR-J",
      "url": "/2023/10/06/maqQ2wqag_1256x620__1.jpg"
  },
  "AR-D": {
      "code": "AR-D",
      "url": "/2023/10/06/oHUJ0ysnk_1256x620__1.jpg"
  },
  "AR-Z": {
      "code": "AR-Z",
      "url": "/2023/10/06/tkYvhQrqB_1256x620__1.jpg"
  },
  "AR-S": {
      "code": "AR-S",
      "url": "/2023/10/06/jcnBI-wpB_1256x620__1.jpg"
  },
  "AR-G": {
      "code": "AR-G",
      "url": "/2023/10/06/bM6nrRvxg_1256x620__1.jpg"
  },
  "AR-V": {
      "code": "AR-V",
      "url": "/2023/10/06/Mf24XNlRb_1256x620__1.jpg"
  },
  "AR-T": {
      "code": "AR-T",
      "url": "/2023/10/06/nBXG-rYB9_1256x620__1.jpg"
  }
}

/**
 * Obtiene la URL de imagen según el código
 */
export function obtenerURLImagen(code, typeElection = "", mesasEscrutadas = 0) {
  if((typeElection == "diputados" || typeElection == "senadores" )){
    if(mesasEscrutadas > 0){
      return {"url": "/2025/09/29/UVK4DFC4r_1256x620__1.jpg"};
    }
    return {"url": "/2025/09/29/zSKaRivKB_1256x620__1.jpg"}
  }
  if (imagePost[code]) {

    return imagePost[code];
  }
  return null;
}

/**
 * Formatea provincia y localidad
 */
export function formatProvinciaLocalidad(text) {
  if (!text) return '';
  // Capitaliza primera letra de cada palabra
  return text.split(' ').map(word => 
    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
  ).join(' ');
}

export function getCodeLetter(string) {
  return string?.match(/([A-Z]{2}-[A-Z])/)?.[0] || string.match(/_([A-Z]{2}(?:-[A-Z])?)[A-Z0-9]*\.html$/)[1]
}

export const buildElectionUrl = (params) => {
  const cleanBase = params.baseUrl.replace(/\/$/, "");

  // Se reemplaza la parte después de "resultados-" por el nuevo resultPath
  const finalUrl = cleanBase.replace(/resultados-[^/]*$/, params.resultPath);

  return finalUrl;
};


/**
 * Parsea parámetros de la URL de elecciones 
 */
// export function parseUrlParams(query) {
//   const [basePath, year, electionType, electionCategory, resultPath] = query;
  
//   // Determinar instancia (general o balotaje)
//   const electionInstance = electionType === 'balotaje' ? 'balotaje' : 'general';
//   const typeElection = electionCategory;
  
//   // Extraer códigos de la URL
//   const parametros = resultPath.match(/([A-Z]{2}-[A-Z]\d{3})\.html/);
//   let codeLetter, codeNumber, codeComplet;
  
//   if (parametros) {
//     codeComplet = parametros[1]; // "AR-C001"
//     const parametros2 = codeComplet.match(/^([A-Z]+-[A-Z]+)(\d+)$/);
    
//     if (parametros2) {
//       codeLetter = parametros2[1]; // "AR-C"
//       codeNumber = parametros2[2]; // "001"
//     } else {
//       codeLetter = codeComplet;
//       codeNumber = "";
//     }
//   }
  
//   // Construir base URL según tipo de elección
//   const dateNow = new Date();
//   let baseUrl, endpoint;
  
//   if (typeElection === 'presidente') {
//     baseUrl = `/elecciones/${year}/${electionType}/presidente/resultados-`;
//     endpoint = `president.json?rv=${dateNow.getHours()}${dateNow.getMinutes()}`;
//   } else if (typeElection === 'legislativas') {
//     baseUrl = `/elecciones/${year}/generales/legislativas/resultados-ciudad-autonoma-bsas-`;
//     endpoint = `legislative.json?rv=${dateNow.getHours()}${dateNow.getMinutes()}`;
//   } else if (typeElection === 'delegados') {
//     baseUrl = `/elecciones/${year}/generales/delegados/resultados-ciudad-autonoma-bsas-`;
//     endpoint = `delegatesprov.json?rv=${dateNow.getHours()}${dateNow.getMinutes()}`;
//   } else if (typeElection === 'senadores') {
//     baseUrl = `/elecciones/${year}/generales/senadores/resultados-`;
//     endpoint = `senators.json?rv=${dateNow.getHours()}${dateNow.getMinutes()}`;
//   } else if (typeElection === 'diputados') {
//     baseUrl = `/elecciones/${year}/generales/diputados/resultados-`;
//     endpoint = `deputies.json?rv=${dateNow.getHours()}${dateNow.getMinutes()}`;
//   } else {
//     baseUrl = `/elecciones/${year}/generales/gobernador/resultados-`;
//     endpoint = `governors.json?rv=${dateNow.getHours()}${dateNow.getMinutes()}`;
//   }
  
//   return {
//     basePath,
//     year,
//     electionType,
//     electionCategory,
//     resultPath,
//     electionInstance,
//     typeElection,
//     codeComplet,
//     codeLetter,
//     codeNumber,
//     baseUrl,
//     endpoint
//   };
// }